import {Entity} from './Entity';

export class EntitySupplier extends Entity {
  constructor(init){
    init.type = "supplier";
    init.totalSlots = 2;
    init.instructionsPath = "http://www.google.com/file.pdf";

    super(init);
  }

  updateDataValues = (values) => {
    //console.log("values:", this, values);
    Object.keys(values).forEach((val) => {
      this[val] = values[val];
    });
  }
}



// WEBPACK FOOTER //
// ./src/classes/EntitySupplier.js